import { Text } from "@ttc3k/trekker";
import { useTranslation } from "react-i18next";
import { Flex } from "styled-system/jsx";
import { Calendar, Shop } from "iconoir-react";
import { NewWidgetStep } from "./useStartNewWidgetModal";
import { SetStateAction } from "react";
import { Dispatch } from "react";
import { ButtonCard } from "shared/components/atoms/ButtonCard/ButtonCard";

type WidgetTypeSelectionProps = {
  setStep: Dispatch<SetStateAction<NewWidgetStep>>;
};

export const WidgetTypeSelection = ({ setStep }: WidgetTypeSelectionProps) => {
  const { t } = useTranslation("widgets", {
    keyPrefix: "CREATE_NEW.WIDGET_TYPE",
  });

  return (
    <Flex gap="200" flexDir="column">
      <Text visual="bodyRegular" color="text.mid">
        {t("TITLE")}
      </Text>
      <Flex
        flexDir="row"
        gap="150"
        justifyContent="space-between"
        alignItems="stretch"
      >
        <ButtonCard
          title={t("TYPE_OPERATOR_TITLE")}
          description={t("TYPE_OPERATOR_DESCRIPTION")}
          Icon={Shop}
          onClick={() => {
            setStep(NewWidgetStep.SelectedOperator);
          }}
        />
        <ButtonCard
          title={t("TYPE_EVENT_TITLE")}
          description={t("TYPE_EVENT_DESCRIPTION")}
          Icon={Calendar}
          onClick={() => {
            setStep(NewWidgetStep.SelectedEvent);
          }}
        />
      </Flex>
    </Flex>
  );
};
